module.exports = __webpack_public_path__ + "static/media/icon-no.439e8214.svg";